import React from 'react';

import { InputLabel } from '@mui/material';

import { IFormFieldLabelProps } from './types';

// TODO: theme override
export const FormFieldLabel: React.FC<IFormFieldLabelProps> = (props) => {
  const { children, ...passProps } = props;

  return <InputLabel {...passProps}>{children}</InputLabel>;
};
